import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DBService } from '../../services/db.service';
import { AuthenticationService } from '../../services/authentication.service';
import { Partner } from '../../model/partner';
import { Address } from '../../model/company';
import { LocationService } from '../../services/location.service';

declare var Materialize: any;

@Component({
  selector: 'app-new-partner',
  templateUrl: './new-partner.component.html',
  styleUrls: ['./new-partner.component.css'],
  providers: [DBService, LocationService]
})
export class NewPartnerComponent implements OnInit {

  phoneMask = ['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  cepMask = [/[0-9]/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/];
  dateMask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  selectedFile: File;

  successMessage: string;
  errorMessage: string;

  partner: Partner;

  loading: boolean;
  isSearching: boolean;
  hasAddress: boolean;

  constructor(private router: Router, private dbService: DBService, private authService: AuthenticationService, private locationService: LocationService) { 
    this.partner = new Partner();
    this.partner.address = new Address();
  }

  ngOnInit() {
  }

  detectFiles(event) {
    this.selectedFile = event.target.files[0];
  }

  onChange(event) {
    const dateParts = this.partner.partnershipDateString.split('/');

    const date = new Date(dateParts[1] + '-' + dateParts[0] + '-' + dateParts[2]);

    if (date.toString() === 'Invalid Date') {
      delete this.partner.partnershipDate;
    } else {
      this.partner.partnershipDate = date.getTime();
    }
  }

  register() {
    this.loading = true;

    this.dbService.uploadFile('partners', this.selectedFile)
      .then(url => {
        this.partner.fileURL = url;

        this.dbService.insertInList('/partners', this.partner)
          .then(() => this.registerSuccess())
          .catch(error => this.registerError(error));
      });
  }

  private registerSuccess() {
    this.loading = false;

    Materialize.toast('Parceiro cadastrado com sucesso', 2000);

    this.router.navigate(['/parceiros']);
  }

  private registerError(error) {
    this.errorMessage = error;
    this.loading = false;
  }

  cancel() {
    this.router.navigate(['/parceiros']);
  }

  searchCep() {
    this.hasAddress = false;
    this.isSearching = true;

    this.locationService.getAddress(this.partner.address.cep)
      .then(address => {
        address.cep = this.partner.address.cep;
        this.partner.address = address;
        this.isSearching = false;

        this.hasAddress = true;
        this.updateLabels();
      })
      .catch(error => {
        console.log(error);
        this.isSearching = false;
      });
  }

  private updateLabels() {
    setTimeout(() => Materialize.updateTextFields(), 100);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/new-partner/new-partner.component.ts